/** Akzentfarben aus der Design-Vorlage (`design/OSCE App.dc.html`, `PALETTES`). */

export const ACCENTS = ['blau', 'gruen', 'rot', 'orange', 'lila', 'tuerkis', 'grau'] as const;

export type Accent = (typeof ACCENTS)[number];

export interface Palette {
  /** Anzeigename in den Einstellungen. */
  label: string;
  /** Trägt Schaltflächen, Regler und alles Aktive. */
  base: string;
  /** Dunklere Stufe für Text auf hellem Akzentgrund. */
  deep: string;
  /** Heller Akzenthintergrund im hellen Modus. */
  soft: string;
  /** Derselbe Hintergrund im dunklen Modus. */
  softDark: string;
  /** Schlagschatten unter aktiven Flächen. */
  glow: string;
}

export const PALETTES: Record<Accent, Palette> = {
  blau: {
    label: 'Blau',
    base: '#2563eb',
    deep: '#1d4ed8',
    soft: '#eff4ff',
    softDark: '#18243c',
    glow: 'rgba(37,99,235,.32)',
  },
  gruen: {
    label: 'Grün',
    base: '#128a5a',
    deep: '#0d6b46',
    soft: '#e7f7ef',
    softDark: '#123328',
    glow: 'rgba(18,138,90,.3)',
  },
  rot: {
    label: 'Rot',
    base: '#dc3626',
    deep: '#b32419',
    soft: '#fdeceb',
    softDark: '#3a1b18',
    glow: 'rgba(220,54,38,.3)',
  },
  orange: {
    label: 'Orange',
    base: '#dd6b0b',
    deep: '#b05308',
    soft: '#fdf1e3',
    softDark: '#3a2612',
    glow: 'rgba(221,107,11,.3)',
  },
  lila: {
    label: 'Lila',
    base: '#7c4ddb',
    deep: '#6135b8',
    soft: '#f2edfd',
    softDark: '#2a2140',
    glow: 'rgba(124,77,219,.3)',
  },
  tuerkis: {
    label: 'Türkis',
    base: '#0e8f9e',
    deep: '#0a6f7b',
    soft: '#e6f6f8',
    softDark: '#0f2f33',
    glow: 'rgba(14,143,158,.3)',
  },
  grau: {
    label: 'Grau',
    base: '#5b6472',
    deep: '#414956',
    soft: '#eef0f3',
    softDark: '#242a33',
    glow: 'rgba(91,100,114,.28)',
  },
};
